import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { PAGINAS, ROUTES, FUNCIONALIDADES } from '../../../routes';
import { getTiposVinculosTrabalhos } from './tipos_vinculos_trabalho.service';
import GridBase from '../../../components/grid_base';
export var TiposVinculosTrabalhosListar = function () {
    var COLUNAS_FUNCIONALIDADE = [
        { field: 'nome', headerName: 'Nome', width: 500 },
        { field: 'situacao', headerName: 'Situação', width: 150 },
    ];
    return (_jsx(GridBase, { pagina: PAGINAS.TIPOS_VINCULOS_TRABALHO, paginaPermissao: FUNCIONALIDADES.TIPOS_VINCULOS_TRABALHO, rota: ROUTES.TIPOS_VINCULOS_TRABALHO, columns: COLUNAS_FUNCIONALIDADE, fetchData: function (str, _, pag) { return getTiposVinculosTrabalhos(str, pag); } }));
};
export default TiposVinculosTrabalhosListar;
